import localforage from 'localforage'
import Api from '../core/Api'
import Offline from './Offline'

class Piece {
    static serialize(data){
        let payload = {};

        payload.id = data.id;
        payload.idFibsdd = data.fiche;
        payload.designation = data.designation;
        payload.changed = data.etat;
        payload.quantity = data.qte;
        payload.price = data.prix;

        return payload;
    }

    static async addOnline(id) {
        let api = await Api.init();
        let piece = await Piece.getPiece(id);
        let payload = Piece.serialize(piece);
        let idFiche = payload.idFibsdd;

        delete payload.idFibsdd;
        delete payload.id;

        let res = await api.post('/piece/' + idFiche, payload);
        let newId = res.data && res.data.id;

        if (newId) {
            let pieces = await Piece.getList();
            let newList = pieces.map(p => {
                if (p.id === id) {
                    p.id = newId;
                }
                return p;
            });

            await localforage.setItem('listPieces', JSON.stringify(newList));
        }

        await Offline.deleteAction(id, 'Piece');
        return true;
    }

    static async removeOnline(id){
        let api = await Api.init();

        try {
            await api.delete('/piece/' + id)
        } catch (err) {
            if (!(err.response && (err.response.status === 403 || err.response.status === 404))) {
                throw err;
            }
        }

        await Offline.deleteAction(id, 'Piece');

        return true;
    }

    static async addOffline(data) {

        try {
            let pieces = await Piece.getList();
            pieces.push(data);
            await localforage.setItem('listPieces', JSON.stringify(pieces));
            await Offline.saveAction({action: 'add', type: 'Piece', id: data.id});

            return true;
        } catch (e) {
            return false;
        }

    }

    static async remove(id) {
        let pieces = await Piece.getList();

        try {
            // Prédicat volontairement inversé : _.remove() retire du tableau les
            // éléments qui matchent et RETOURNE ces éléments retirés — ici on
            // persiste donc bien la liste sans l'élément ciblé (double inversion
            // prédicat + valeur persistée). Ne pas "corriger" l'un sans l'autre.
            let newList = _.remove(pieces, p => p.id !== id);
            await localforage.setItem('listPieces', JSON.stringify(newList));

            if(!_.includes(id, 'P-')){
                Offline.saveAction({
                    type: "Piece",
                    action: "delete",
                    id: id
                })
            } else {
                Offline.deleteAction(id, 'Piece')
            }
        } catch (err) {
            return false
        }

        return true
    }

    static async getListForFiche(idFiche) {
        let pieces = await Piece.getList();

        return pieces.filter( p => p.fiche == idFiche );
    }

    static async getPiece(id) {
        let list = await Piece.getList();

        return list.find( p => p.id === id );
    }

    static async getList() {
        const parsed = JSON.parse(await localforage.getItem('listPieces'));
        return Array.isArray(parsed) ? parsed : [];
    }
}

export default Piece



// WEBPACK FOOTER //
// ./src/js/models/Piece.js